/* MD Producto galería: miniaturas, flechas, deslizamiento táctil, visor ampliado y cambio por variante */
(function () {
  'use strict';

  var ROOT = '.md-producto-galeria';

  /*
    Cambio de variante: el selector de tallas del tema (variant-picker) emite el evento estándar
    de Shopify "shopify:product:select" (ProductSelectEvent de @shopify/events). Burbujea hasta document y
    lleva una promesa (event.promise) que se resuelve, cuando llega la respuesta del servidor, con
    { variant, detail: { productId, resource } }; "resource" es la variante en JSON, con
    featured_media.id / featured_image.id. Se escucha en document porque el selector vive en otra
    sección de la plantilla, y se filtra por el id del producto de esta galería.
  */
  var VARIANT_EVENT = 'shopify:product:select';
  var SWIPE_MIN_PX = 40;

  /* Limpieza por instancia para el evento unload del editor */
  var cleanups = new WeakMap();

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function setDisabled(button, disabled) {
    if (!button) return;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    var slides = toArray(container.querySelectorAll('.md-producto-galeria__slide'));
    var total = slides.length;
    if (!total) return;

    var cover = container.querySelector('.md-producto-galeria__cover');
    var thumbs = toArray(container.querySelectorAll('.md-producto-galeria__thumb'));
    var statuses = toArray(container.querySelectorAll('.md-producto-galeria__status'));
    var expandBtn = container.querySelector('.md-producto-galeria__expand');
    var dialog = container.querySelector('.md-producto-galeria__lightbox');
    var lbSlides = dialog ? toArray(dialog.querySelectorAll('.md-producto-galeria__lb-slide')) : [];
    var lbThumbs = dialog ? toArray(dialog.querySelectorAll('.md-producto-galeria__lb-thumb')) : [];
    var prevBtns = toArray(container.querySelectorAll('.md-producto-galeria__arrow--prev'));
    var nextBtns = toArray(container.querySelectorAll('.md-producto-galeria__arrow--next'));
    var closeBtn = dialog ? dialog.querySelector('.md-producto-galeria__lb-close') : null;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var productId = container.dataset.productId || '';
    var lastFocus = null;
    var previousOverflow = '';

    var current = 0;
    for (var s = 0; s < total; s++) {
      if (slides[s].classList.contains('md-producto-galeria__slide--active')) current = s;
    }

    function markActive(items, className, index) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle(className, i === index);
      }
    }

    function markCurrent(buttons, index) {
      for (var i = 0; i < buttons.length; i++) {
        if (i === index) {
          buttons[i].setAttribute('aria-current', 'true');
        } else {
          buttons[i].removeAttribute('aria-current');
        }
      }
    }

    function scrollThumbIntoView(button) {
      if (!button || typeof button.scrollIntoView !== 'function') return;
      button.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    function show(index) {
      if (index < 0 || index >= total) return;
      current = index;

      markActive(slides, 'md-producto-galeria__slide--active', index);
      markActive(lbSlides, 'md-producto-galeria__lb-slide--active', index);
      markCurrent(thumbs, index);
      markCurrent(lbThumbs, index);

      for (var i = 0; i < prevBtns.length; i++) setDisabled(prevBtns[i], index === 0);
      for (var j = 0; j < nextBtns.length; j++) setDisabled(nextBtns[j], index === total - 1);

      var text = 'Imagen ' + (index + 1) + ' de ' + total;
      for (var k = 0; k < statuses.length; k++) statuses[k].textContent = text;

      scrollThumbIntoView(thumbs[index]);
      if (dialog && dialog.open) scrollThumbIntoView(lbThumbs[index]);
    }

    function step(direction) {
      show(current + direction);
    }

    function onArrowClick(direction) {
      return function () {
        if (this.getAttribute('aria-disabled') === 'true') return;
        step(direction);
      };
    }

    function onThumbClick(e) {
      var btn = e.target.closest('[data-index]');
      if (!btn) return;
      var index = parseInt(btn.dataset.index, 10);
      if (!isNaN(index)) show(index);
    }

    /* Zoom al pasar el ratón (solo en el visor ampliado): el origen de la transformación sigue al
       cursor mediante variables CSS en la caja; la clase --zoom activa la escala */
    function bindZoom(box, zoomClass) {
      if (!box) return;
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
        box.style.setProperty('--md-producto-galeria-zoom-x', x.toFixed(1) + '%');
        box.style.setProperty('--md-producto-galeria-zoom-y', y.toFixed(1) + '%');
        box.classList.add(zoomClass);
      });
      box.addEventListener('mouseleave', function () {
        box.classList.remove(zoomClass);
      });
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      bindZoom(dialog ? dialog.querySelector('.md-producto-galeria__lb-frame') : null, 'md-producto-galeria__lb-frame--zoom');
    }

    for (var p = 0; p < prevBtns.length; p++) prevBtns[p].addEventListener('click', onArrowClick(-1));
    for (var n = 0; n < nextBtns.length; n++) nextBtns[n].addEventListener('click', onArrowClick(1));

    var thumbLists = toArray(container.querySelectorAll('.md-producto-galeria__thumbs, .md-producto-galeria__lb-thumbs'));
    for (var t = 0; t < thumbLists.length; t++) thumbLists[t].addEventListener('click', onThumbClick);

    /* Deslizamiento táctil sobre la portada y sobre el visor */
    function bindSwipe(surface) {
      if (!surface) return;
      var startX = 0;
      var startY = 0;
      var tracking = false;

      surface.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      surface.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy)) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    bindSwipe(cover);

    /* Visor ampliado: diálogo nativo (Escape cierra por defecto; el fondo queda inerte) */
    var lightboxOk = dialog && typeof dialog.showModal === 'function';

    function openLightbox() {
      if (!lightboxOk || dialog.open) return;
      lastFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      show(current);
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (!lightboxOk || !dialog.open) return;
      dialog.close();
    }

    if (lightboxOk) {
      bindSwipe(dialog.querySelector('.md-producto-galeria__lb-stage'));

      if (expandBtn) expandBtn.addEventListener('click', openLightbox);
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

      /* Clic fuera del panel (sobre el fondo oscurecido) cierra */
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeLightbox();
      });

      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          step(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          step(1);
        }
      });

      /* Al cerrar (botón, Escape o fondo): restaurar scroll y devolver el foco al botón de ampliar */
      dialog.addEventListener('close', function () {
        document.documentElement.style.overflow = previousOverflow;
        var target = lastFocus && document.contains(lastFocus) ? lastFocus : expandBtn;
        if (target && typeof target.focus === 'function') target.focus();
        lastFocus = null;
      });
    } else if (expandBtn) {
      expandBtn.hidden = true;
    }

    /* Cambio de variante: mostrar la imagen asociada a la variante elegida */
    function indexByMediaId(mediaId) {
      for (var i = 0; i < total; i++) {
        if (slides[i].dataset.mediaId === mediaId) return i;
      }
      return -1;
    }

    function onProductSelect(e) {
      var origin = e.target;
      if (origin && origin.closest && origin.closest('product-card')) return;
      if (!e.promise || typeof e.promise.then !== 'function') return;

      e.promise.then(function (result) {
        var detail = result && result.detail;
        if (!detail || !detail.resource) return;
        if (detail.productId && String(detail.productId) !== productId) return;

        /* Solo featured_media: featured_image.id es el id de la imagen, no el del medio, y no casa con data-media-id */
        var resource = detail.resource;
        var mediaId = resource.featured_media && resource.featured_media.id;
        if (!mediaId) return;

        var index = indexByMediaId(String(mediaId));
        if (index >= 0 && index !== current) show(index);
      }).catch(function () {
        /* Petición cancelada por otra selección más reciente: no hay nada que actualizar */
      });
    }

    document.addEventListener(VARIANT_EVENT, onProductSelect);

    cleanups.set(container, function () {
      document.removeEventListener(VARIANT_EVENT, onProductSelect);
      if (lightboxOk && dialog.open) dialog.close();
    });

    show(current);
  }

  function destroySection(container) {
    var cleanup = cleanups.get(container);
    if (!cleanup) return;
    cleanup();
    cleanups.delete(container);
    delete container.dataset.mdInit;
  }

  var sections = document.querySelectorAll(ROOT);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(ROOT);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(ROOT);
    if (section) destroySection(section);
  });
})();
